import BigNumber from 'bignumber.js'

export const PARTIAL_REPAY_SAFETY_MULTIPLIER = 0.995

export function formatRepayAmount(amount: number): string {
  if (amount === 0) return '0'
  const bigAmount = new BigNumber(amount)

  if (amount >= 0.000001) {
    return bigAmount
      .decimalPlaces(6, BigNumber.ROUND_DOWN)
      .toFixed()
      .replace(/\.?0+$/, '')
  }

  return bigAmount
    .decimalPlaces(18, BigNumber.ROUND_DOWN)
    .toFixed()
    .replace(/\.?0+$/, '')
}

interface GetPercentFromAmountArgs {
  amount: number
  maxRepayAmount: number
  safetyMultiplier?: number
}

export function getPercentFromAmount({
  amount,
  maxRepayAmount,
  safetyMultiplier = PARTIAL_REPAY_SAFETY_MULTIPLIER,
}: GetPercentFromAmountArgs): number {
  if (maxRepayAmount <= 0) return 0
  if (amount >= maxRepayAmount) return 100
  if (amount <= 0) return 0

  const adjustedBase = maxRepayAmount * safetyMultiplier
  const percent = (amount / adjustedBase) * 100
  // Keep partial inputs strictly below 100% so they don't trigger full-repay logic.
  return Math.min(Math.max(0, percent), 100 - 100 * Number.EPSILON)
}
